import React from 'react';

import './shimmerComponent.css';

const ShimmerComponent = () => {
  return <div className="et-shimmer-shine"></div>;
};

export default ShimmerComponent;
